import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import { appBar } from '../Styles'
const PreferencesScreen = props => {
  const fullUser = (props.me && props.me.only_forecasts === 0) ? true : false

  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Preferencias</Typography>
          </div>
        </Toolbar>
      )}>
      {props.preferences && (
        <div className={props.classes.main}>
          <div>
            <Typography className={props.classes.headNoPaddingBottom}>Cambiar contraseña</Typography>
          </div>

          <Grid container spacing={16}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Contraseña"
                type="password"
                variant="outlined"
                fullWidth
                value={props.oldPassword}
                onChange={event => props.onOldPasswordChange(event.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Nueva Contraseña"
                type="password"
                variant="outlined"
                fullWidth
                value={props.newPassword}
                onChange={event => props.onNewPasswordChange(event.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Confirmar Contraseña"
                type="password"
                variant="outlined"
                fullWidth
                value={props.confirmNewPassword}
                onChange={event => props.onConfirmNewPasswordChange(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" color="primary" size="small" onClick={props.onChangePassword}>
                Cambiar contraseña
              </Button>
            </Grid>
          </Grid>

          {fullUser && (
            <React.Fragment>
            <div style={{ marginTop: 30 }}>
              <Typography className={props.classes.head}>Notificaciones</Typography>
            </div>

            <Grid container spacing={16}>
              <Grid item xs={12} sm={6} md={4}>
                <div className={props.classes.preference}>
                  <Grid container alignItems="center" justify="space-between">
                    <Grid item xs={10}>
                      <Typography className={props.classes.preferenceLabel}>
                        Activar notificaciones de entradas
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Switch
                        color="primary"
                        checked={props.preferences.entriesNotificationsEnabled !== false}
                        onChange={(e, checked) => props.savePreference('entriesNotificationsEnabled', checked)}
                      />
                    </Grid>
                  </Grid>
                  {props.preferences.entriesNotificationsEnabled !== false && (
                    <div className={props.classes.preferenceBody}>
                      <Select
                        classes={{
                          select: props.classes.select,
                          root: props.classes.select,
                          selectMenu: props.classes.select,
                        }}
                        value={props.preferences.entriesNotificationsFrecuency || 'all'}
                        onChange={e => props.savePreference('entriesNotificationsFrecuency', e.target.value)}>
                        <MenuItem value="all">Todas las notificaciones</MenuItem>
                        <MenuItem value="morning">Resumen a primera hora de la mañana (9:00)</MenuItem>
                        <MenuItem value="afternoon">Resumen al medio día (15:00)</MenuItem>
                        <MenuItem value="evening">Resumen a la noche (22:00)</MenuItem>
                      </Select>
                    </div>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className={props.classes.preference}>
                  <Grid container alignItems="center" justify="space-between">
                    <Grid item xs={10}>
                      <Typography className={props.classes.preferenceLabel}>
                        Activar notificaciones de clasificaciones
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Switch
                        color="primary"
                        checked={props.preferences.samplingsNotificationsEnabled !== false}
                        onChange={(e, checked) => props.savePreference('samplingsNotificationsEnabled', checked)}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className={props.classes.preference}>
                  <Grid container alignItems="center" justify="space-between">
                    <Grid item xs={10}>
                      <Typography className={props.classes.preferenceLabel}>
                        Activar notificaciones de facturas
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Switch
                        color="primary"
                        checked={props.preferences.invoicesNotificationsEnabled !== false}
                        onChange={(e, checked) => props.savePreference('invoicesNotificationsEnabled', checked)}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
            </React.Fragment>
          )}
        </div>
      )}
    </Page>
  )
}

const styles = {
  appBar,
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  main: {
    padding: 15,
  },
  head: {
    fontSize: 18,
    fontWeight: 600,
    paddingBottom: 15,
  },
  headNoPaddingBottom: {
    fontSize: 18,
    fontWeight: 600,
  },
  preference: {
    padding: 10,
    border: '1px solid #DDD',
    marginBottom: 10,
    cursor: 'pointer',
  },
  preferenceLabel: {
    fontSize: 15,
  },
  preferenceBody: {
    marginTop: -5,
    paddingBottom: 10,
  },
  preferenceInfo: {
    fontSize: 11,
    marginTop: 5,
  },
  select: {
    fontSize: 15,
    width: '100%',
  },
}

export default withStyles(styles)(PreferencesScreen)



// WEBPACK FOOTER //
// ./src/screens/PreferencesScreen.js